<template>
  <div class="qa-item" @click="goDes">
    <div class="qa-title"><i class="qa-icon"></i> {{ detailInfo.title }}</div>
    <!-- <div class="user-info">
      <div class="avatar">
        <img :src="basicInfo.avatar | imgZip(100)" alt="头像" />
        <span class="name">{{ basicInfo.nickname }}</span>
      </div>
      <div class="level" v-if="firstIdentity">
        <img
          class="icon-level"
          :src="firstIdentity.image | imgZip(54)"
          alt=""
        />
        <span class="level-text">{{ firstIdentity.name }}</span>
      </div>
    </div> -->
    <div class="content">
      <YxlMore
        v-if="detailInfo.content"
        :isClickShow="false"
        :lineClamp="4"
        :info="insertAnswerIcon(detailInfo.content)"
        @hook:updated="yxlMoreUpdated"
      ></YxlMore>
    </div>
    <HandList :info="interactive"></HandList>
  </div>
</template>
<script>
import YxlMore from 'component/common/yxlMore.vue'
import HandList from 'component/platform/homepage/common/handList.vue'
import { imgZip } from 'app/web/filters/ossImg.js'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
export default {
  mixins: [homepageMixin],
  props: {
    qaInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    YxlMore,
    HandList
  },
  data() {
    return {}
  },
  computed: {
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    detailInfo() {
      return this.qaInfo.detail_info || ''
    },
    interactive() {
      return this.qaInfo.interactive || ''
    },
    firstIdentity() {
      return this.$store.getters['homepage/firstIdentity']
    }
  },
  created() {},
  mounted() {},
  methods: {
    imgZip,
    yxlMoreUpdated() {
      this.$emit('updated')
    },
    // 插入回答图标
    insertAnswerIcon(content) {
      if (!content) return ''
      const IconA = require('../../../../images/platform/homepage/inter-a.png')
      const IconAEl = `<span style="
                          display: inline-block;
                          margin: 0 0.3vw 0 0;
                          width: 5.067vw;
                          height: 5.067vw;
                          background: url('${IconA}') no-repeat center/100% 100%;
                          vertical-align: -18%;">
                        </span>
                        ${content}`
      const IconQEl = `<span style="
                          display: inline-block;
                          padding: 0 0.8vw;
                          height: 4vw;
                          background: #FFFFFF;
                          border-radius: 0.8vw;
                          border: 0.133vw solid #6982FA;
                          font-size: 2.933vw;
                          color: #6982FA;
                          line-height: 4vw;
                          vertical-align: 10%;">
                          问题描述
                        </span>
                        ${content}`
      return this.detailInfo?.type == 'answer' ? IconAEl : IconQEl
    },
    // 跳转到问答详情
    goDes() {
      let url = ''
      if (this.detailInfo?.type == 'answer') {
        this.$emit('goAnswerDes')
        url = `https://m.xinli001.com/qa/answer-${this.detailInfo.id}`
      } else {
        this.$emit('goQuestionDes')
        url = this.mixinIsApp
          ? `yixinli://open_question?question_id=${this.detailInfo.id}`
          : `https://m.xinli001.com/qa/${this.detailInfo.id}`
      }
      this.routerPush(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.qa-item {
  padding: 30px;
  margin-bottom: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff, 0px 0px 40px 0px rgba(0, 0, 0, 0.03);
  border-radius: 30px;
  overflow: hidden;
  .qa-title {
    font-size: 32px;
    font-weight: 600;
    color: #21252d;
    line-height: 57px;
    text-shadow: 0px 0px 40px #ebefff;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    .qa-icon {
      display: inline-block;
      margin: 0 10px 0 0;
      width: 38px;
      height: 38px;
      background: url('../../../../images/platform/homepage/inter-q.png')
        no-repeat center/100% 100%;
      vertical-align: middle;
    }
  }
  .user-info {
    display: flex;
    align-items: center;
    margin-top: 26px;
    line-height: 40px;
    .avatar {
      display: flex;
      align-items: center;
      > img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        object-fit: cover;
      }
      .name {
        max-width: 400px;
        margin-left: 10px;
        font-size: 26px;
        color: #21252d;
        text-shadow: 0px 0px 40px #ebefff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .level {
      margin-left: 20px;
      display: flex;
      align-items: center;
      .icon-level {
        width: 40px;
        height: 40px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 6px;
        object-fit: cover;
      }
      .level-text {
        font-size: 20px;
        color: #6c798c;
        text-shadow: 0px 0px 40px #ebefff;
      }
    }
  }
  .content {
    margin-top: 30px;
    font-size: 30px;
    color: #6c798c;
    line-height: 49px;
    text-shadow: 0px 0px 40px #ebefff;
  }
}
</style>
